"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Button_1 = require("./Button");
const Scroller_1 = require("./Scroller");
const store_1 = require("./store");
const flex_scss_1 = __importDefault(require("./styles/flex.scss"));
const map_view_scss_1 = __importDefault(require("./styles/map-view.scss"));
const selector_scss_1 = __importDefault(require("./styles/selector.scss"));
exports.tabs = ['mine', 'ours'];
function MapView({}) {
    const [tab, setTab] = React.useState('mine');
    const refs = {
        mine: React.useRef(null),
        ours: React.useRef(null)
    };
    const handleScroll = React.useCallback((e) => {
        const margin = 20; // safety margin for smooth scroll [px]
        const viewTop = e.currentTarget.offsetTop + e.currentTarget.scrollTop + margin;
        for (const tab of exports.tabs) {
            const element = refs[tab].current;
            if (!element)
                return;
            const groupBottom = element.offsetTop + element.offsetHeight;
            if (viewTop < groupBottom) {
                setTab(tab);
                return;
            }
        }
    }, []);
    const scrollTo = React.useCallback((tab) => {
        const element = refs[tab].current;
        if (!element)
            return;
        element.scrollIntoView({ behavior: 'smooth' });
    }, []);
    const selected = react_redux_1.useSelector((state) => state.floor.selected);
    const maps = {
        mine: react_redux_1.useSelector((state) => state.floor.mine),
        ours: react_redux_1.useSelector((state) => state.floor.ours)
    };
    return (React.createElement("div", { className: map_view_scss_1.default.container },
        React.createElement("h2", null,
            "Choose background of map",
            selected),
        React.createElement("div", { className: selector_scss_1.default.container },
            React.createElement("button", { className: classnames_1.default(selector_scss_1.default.item, tab === 'mine' && selector_scss_1.default.selected), onClick: () => scrollTo('mine') }, "Mine"),
            React.createElement("button", { className: classnames_1.default(selector_scss_1.default.item, tab === 'ours' && selector_scss_1.default.selected), onClick: () => scrollTo('ours') }, "Ours")),
        React.createElement(Scroller_1.Scroller, { ms: 50, className: map_view_scss_1.default.scroller, onScroll: handleScroll }, exports.tabs.map(id => (React.createElement("div", { key: id, id: id, className: map_view_scss_1.default.group, ref: refs[id] }, maps[id].map(map => (React.createElement(MapViewItem, { key: map.id, map: map })))))))));
}
exports.MapView = MapView;
function MapViewItem({ map }) {
    const dispatch = react_redux_1.useDispatch();
    const onClick = React.useCallback(() => {
        dispatch(store_1.actions.setEditorMode(store_1.EditorMode.Code));
    }, []);
    return (React.createElement("div", { className: map_view_scss_1.default.responsive },
        React.createElement("div", { className: map_view_scss_1.default.responsiveContent },
            React.createElement("div", { className: map_view_scss_1.default.item, style: { backgroundImage: `url(${map.thumbnailUrl})` } },
                React.createElement("div", { className: classnames_1.default(map_view_scss_1.default.footer, flex_scss_1.default.horizontal) },
                    React.createElement("div", { className: flex_scss_1.default.vertical },
                        React.createElement("span", null, map.name),
                        React.createElement("span", null,
                            "by ",
                            map.authorName)),
                    React.createElement(Button_1.Button, { primary: true, onClick: onClick }, "Apply"))))));
}
exports.MapViewItem = MapViewItem;
